/** Linkuri și identificatori pentru aplicația mobilă FinComPay. */
export const MOBILE_APP = {
  personalLandingUrl: "https://new.fincompay.com",
  businessQr: "https://qrco.de/bdAWTF",
  ios: {
    appStoreId: "1387938038",
    appStoreUrl: "https://apps.apple.com/app/id1387938038",
    bundleId: "md.fincombank.mobile",
    teamId: "99Z5638392",
  },
  android: {
    packageName: "md.fincombank.fincompay",
    playStoreUrl:
      "https://play.google.com/store/apps/details?id=md.fincombank.fincompay",
  },
} as const;

export const isIosDevice = (): boolean =>
  typeof navigator !== "undefined" &&
  /iPhone|iPad|iPod/i.test(navigator.userAgent);

export const isAndroidDevice = (): boolean =>
  typeof navigator !== "undefined" && /Android/i.test(navigator.userAgent);

export const isMobileDevice = (): boolean => isIosDevice() || isAndroidDevice();

/** Link pentru QR „Personal” (pagină bancă — valid pe orice device). */
export const getPersonalQrLink = (): string =>
  process.env.REACT_APP_FINCOMPAY_QR_URL?.trim() ||
  MOBILE_APP.personalLandingUrl;

/** Descărcare: store nativ pe mobil, pagină bancă pe desktop. */
export const getAppDownloadUrl = (): string => {
  const fromEnv = process.env.REACT_APP_FINCOMPAY_APP_STORE_URL?.trim();
  if (fromEnv) return fromEnv;
  if (isIosDevice()) return MOBILE_APP.ios.appStoreUrl;
  if (isAndroidDevice()) return MOBILE_APP.android.playStoreUrl;
  return MOBILE_APP.personalLandingUrl;
};

/** @deprecated Folosește getAppDownloadUrl */
export const getAppOpenUrl = getAppDownloadUrl;
